// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"112":"a9a7754c","218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"112":"ad7e20abba363c7cf076","218":"09c0adeb79e74a0233a3","691":"0f96cec82694d9b8d77b"}[chunkId] + ".js";
};